// file: src/pages/landing/components/EmptyState.jsx
import React from 'react';
import { Package, FolderPlus } from 'lucide-react';
import ProtectedAction from '../../../components/common/ProtectedAction';
import styles from './EmptyState.module.css';

/**
 * EmptyState component displays when no projects exist
 * @param {Function} onCreateProject - Callback when "Create Your First Project" is clicked
 */
function EmptyState({ onCreateProject }) {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateContainer}>
        <div className={styles.emptyStateIcon}>
          <Package className="h-8 w-8" />
        </div>
        <h3 className={styles.emptyStateTitle}>Start your first project</h3>
        <p className={styles.emptyStateDescription}>Create a new project to begin designing and collaborating</p>
        <ProtectedAction feature="create_project">
        <button
          onClick={onCreateProject}
          className={styles.createProjectButton}
        >
          <FolderPlus className={styles.createProjectButtonIcon} />
          Create Your First Project
        </button>
        </ProtectedAction>
      </div>
    </div>
  );
}

export default EmptyState;
